import styled, { css } from 'styled-components';

export const HeadTextContainer = styled.div`
    font-family: "museo sans";
    font-weight: 500;
    font-size: 20px;
    line-height: 22px;
    
    ${props => css`
        color: ${props.color}
    `}




`;